import React, { useEffect } from "react";
import breadcrumb_shape1 from "../assets/img/images/breadcrumb_shape01.png";
import breadcrumb_shape2 from "../assets/img/images/breadcrumb_shape02.png";
import blog_1 from "../assets/img/blog/h3_blog_img01.jpg";
import blog_2 from "../assets/img/blog/blog_avatar01.png";
import blog_3 from "../assets/img/blog/h3_blog_img02.jpg";
import blog_4 from "../assets/img/blog/blog_avatar02.png";
import blog_5 from "../assets/img/blog/h3_blog_img03.jpg";
import blog_6 from "../assets/img/blog/blog_avatar03.png";
import blog_7 from "../assets/img/blog/h3_blog_img04.jpg";
import blog_8 from "../assets/img/blog/blog_avatar04.png";
import blog_9 from "../assets/img/blog/h3_blog_img05.jpg";
import blog_10 from "../assets/img/blog/blog_avatar05.png";
import blog_11 from "../assets/img/blog/h3_blog_img06.jpg";
import blog_12 from "../assets/img/blog/blog_avatar06.png";
import post1 from "../assets/img/blog/rc_post01.jpg";
import post2 from "../assets/img/blog/rc_post02.jpg";
import post3 from "../assets/img/blog/rc_post03.jpg";
import post4 from "../assets/img/blog/rc_post04.jpg";
import { Link } from "react-router-dom";
import AOS from "aos";
const Events = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <>
      <button class="scroll-top scroll-to-target" data-target="html">
        <i class="fas fa-angle-up"></i>
      </button>
      <main class="fix">
        <section class="breadcrumb-area text-left">
          <div class="container">
            <div class="row">
              <div class="col-lg-12">
                <div class="breadcrumb-content">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                      <li class="breadcrumb-item">
                        <Link to="/">Home</Link>
                      </li>
                      <li class="breadcrumb-item active" aria-current="page">
                        Events
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div class="breadcrumb-shape-wrap">
            <img src={breadcrumb_shape1} alt="" />
            <img src={breadcrumb_shape2} alt="" />
          </div>
        </section>

        <section class="blog-area pt-50 pb-100">
          <div class="container">
            <div class="inner-blog-wrap">
              <div class="row justify-content-center">
                <div class="col-71">
                  <div class="blog-post-wrap">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="event-details">
                              <img src={blog_1} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Development
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_2} alt="" />
                                    Kat Doven
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="/event-details">
                              <img src={blog_3} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Business
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_4} alt="" />
                                    Floyd Miles
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="/event-details">
                              <img src={blog_5} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Tax Advisory
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_6} alt="" />
                                    Bessie Cooper
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="/event-details">
                              <img src={blog_7} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Business
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_8} alt="" />
                                    Devon Lane
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="/event-details">
                              <img src={blog_9} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Consultancy
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_10} alt="" />
                                    Annette Black
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="blog-post-item-two">
                          <div class="blog-post-thumb-two">
                            <Link to="/event-details">
                              <img src={blog_11} alt="" />
                            </Link>
                            <Link to="/blogs" class="tag tag-two">
                              Finance
                            </Link>
                          </div>
                          <div class="blog-post-content-two">
                            <h2 class="title">
                              <Link to="/event-details">
                                Meet AutoManage, the best AI management tools
                              </Link>
                            </h2>
                            <p>
                              Everything you need to start building area atching
                              presence for your business.
                            </p>
                            <div class="blog-meta">
                              <ul class="list-wrap">
                                <li>
                                  <Link to="/event-details">
                                    <img src={blog_12} alt="" />
                                    Eleanor Pena
                                  </Link>
                                </li>
                                <li>
                                  <i class="far fa-calendar"></i>22 Jan, 2023
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pagination-wrap mt-30">
                      <nav aria-label="Page navigation example">
                        <ul class="pagination list-wrap">
                          <li class="page-item">
                            <a class="page-link" href="#">
                              <i class="fas fa-angle-double-left"></i>
                            </a>
                          </li>
                          <li class="page-item active">
                            <a class="page-link" href="#">
                              1
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              2
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              3
                            </a>
                          </li>
                          <li class="page-item">
                            <a class="page-link" href="#">
                              4
                            </a>
                          </li>
                          <li class="page-item next-page">
                            <a class="page-link" href="#">
                              <i class="fas fa-angle-double-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div class="col-29">
                  <aside class="blog-sidebar">
                    <div class="sidebar-search">
                      <form action="#">
                        <input type="text" placeholder="Search Here . . ." />
                        <button type="submit">
                          <i class="flaticon-search"></i>
                        </button>
                      </form>
                    </div>

                    <div class="blog-widget">
                      <h4 class="bw-title">Recent Posts</h4>
                      <div class="rc-post-wrap">
                        <div class="rc-post-item">
                          <div class="thumb">
                            <Link to="/event-details">
                              <img src={post1} alt="" />
                            </Link>
                          </div>
                          <div class="content">
                            <span class="date">
                              <i class="far fa-calendar"></i>22 Jan, 2023
                            </span>
                            <h2 class="title">
                              <Link to="/event-details">
                                Whale be raised must be in a month
                              </Link>
                            </h2>
                          </div>
                        </div>
                        <div class="rc-post-item">
                          <div class="thumb">
                            <Link to="/event-details">
                              <img src={post2} alt="" />
                            </Link>
                          </div>
                          <div class="content">
                            <span class="date">
                              <i class="far fa-calendar"></i>22 Jan, 2023
                            </span>
                            <h2 class="title">
                              <Link to="/event-details">
                                Whale be raised must be in a month
                              </Link>
                            </h2>
                          </div>
                        </div>
                        <div class="rc-post-item">
                          <div class="thumb">
                            <Link to="/event-details">
                              <img src={post3} alt="" />
                            </Link>
                          </div>
                          <div class="content">
                            <span class="date">
                              <i class="far fa-calendar"></i>22 Jan, 2023
                            </span>
                            <h2 class="title">
                              <Link to="/event-details">
                                Whale be raised must be in a month
                              </Link>
                            </h2>
                          </div>
                        </div>
                        <div class="rc-post-item">
                          <div class="thumb">
                            <Link to="/event-details">
                              <img src={post4} alt="" />
                            </Link>
                          </div>
                          <div class="content">
                            <span class="date">
                              <i class="far fa-calendar"></i>22 Jan, 2023
                            </span>
                            <h2 class="title">
                              <Link to="/event-details">
                                Whale be raised must be in a month
                              </Link>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Events;
